import React, { memo, useEffect } from "react";
import { initFlowbite, PlusCircleIcon } from "@";

const ModalOpenBtn = (props) => {
  useEffect(() => {
    initFlowbite();
  }, []);

  const btnVariant = props.variant || "btn-green";
  const isPrimary = btnVariant === "btn-green";
  const modalTitleClassName = props.modalTitleClassName || "";
  return (
    <button
      disabled={props.disabled}
      type="button"
      className={`group relative flex items-center justify-center gap-2 overflow-hidden font-semibold transition-all duration-200 hover:-translate-y-px hover:shadow-sm hover:shadow-purple-900/30 active:translate-y-0 disabled:cursor-not-allowed disabled:text-wrap disabled:bg-gray-300 disabled:hover:shadow-none ${
        isPrimary
          ? "ring-1 ring-white/10 hover:-translate-y-px hover:shadow-sm hover:shadow-purple-900/30 active:translate-y-0 disabled:translate-y-0 disabled:ring-0 disabled:hover:translate-y-0"
          : ""
      } ${btnVariant} ${props.style || ""} ${props.hidden ? "hidden" : ""}`}
      onClick={props.handleClick}
      data-modal-target={props.target || "main-modal"}
      data-modal-toggle={props.target || "main-modal"}
    >
      {/* Sheen on primary variant */}
      {isPrimary && (
        <span
          aria-hidden
          className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/15 to-transparent transition-transform duration-700 group-hover:translate-x-full"
        />
      )}
      {!props.children && (
        <PlusCircleIcon className="relative h-5 w-5 transition-transform group-hover:rotate-90" />
      )}
      {props.children && (
        <span className="relative inline-flex">{props.children}</span>
      )}
      {props.title && (
        <span className={`relative inline-block ${modalTitleClassName}`}>{props.title}</span>
      )}
    </button>
  );
};

export default memo(ModalOpenBtn);
